// @flow

import { VERSION, GIT_REVISION } from '@alphaott/smart-tv-config'
import {
  getManufacturer,
  getDeviceModel,
  getOs,
  getOsVersion,
  getDeviceId,
} from '@alphaott/smart-tv-current-device/selectors'
import { getCustomerId } from '@alphaott/app-core/selectors'
import { getDeviceType } from '@alphaott/smart-tv-platforms/src/utils/getDeviceType'

import store from '../../redux/store'

export type CrashContext = {
  version: string,
  revision: string,
  tag: string,
  os: string,
  osVersion: string,
  brand: string,
  model: string,
  deviceId: string,
  customerId: string,
}

export const EMPTY_CRASH_CONTEXT: CrashContext = {
  version: '',
  revision: '',
  tag: '',
  os: '',
  osVersion: '',
  brand: '',
  model: '',
  deviceId: '',
  customerId: '',
}

// Every field is read on its own: the app state may be half-initialised or broken
const readString = (read: () => mixed): string => {
  try {
    const value = read()

    return typeof value === 'string' ? value : ''
  } catch (e) {
    return ''
  }
}

const readState = (): ?Object => {
  try {
    return store.getState()
  } catch (e) {
    return null
  }
}

export const collectCrashContext = (): CrashContext => {
  const state = readState()
  const select = (selector) => readString(() => (state ? selector(state) : ''))

  return {
    version: readString(() => VERSION),
    revision: readString(() => GIT_REVISION),
    // Release builds are deployed under the build tag, e.g. /1.7.10-113/
    tag: readString(() => process.env.REACT_APP_API_PATHNAME),
    // Device info arrives asynchronously on webOS, so an early crash falls back to the user agent
    os: select(getOs) || readString(getDeviceType),
    osVersion: select(getOsVersion),
    brand: select(getManufacturer),
    model: select(getDeviceModel),
    deviceId: select(getDeviceId),
    customerId: select(getCustomerId),
  }
}
